<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="text-inherit">View Pre-Releases</h3>

        <div v-if="!isOnNative">
          <div
            v-for="(preRelease, idx) in preReleases"
            :key="idx"
            class="col-12 my-4 card bg-light"
          >
            <a :href="preReleaseLegacyLinks[idx]">
              <div
                class="row pre-release card-body rounded bg-light py-3 d-flex"
              >
                <div class="col-2 icon-container d-flex align-items-center">
                  <i class="material-icons mr-1">get_app</i>
                </div>
                <div class="col-6 d-flex align-items-center">
                  <div class>
                    <h5>{{ preRelease }}</h5>
                  </div>
                </div>
                <div
                  class="col-4 d-flex align-items-center justify-content-end"
                >
                  <button
                    class="btn btn-primary d-flex align-items-center justify-content-center my-4"
                  >
                    <i class="material-icons mr-1">cloud_download</i>
                    Download
                  </button>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div v-else>
          <div class="alert alert-secondary mt-4" role="alert">
            <p class="mb-0 d-flex align-content-center">
              <i class="material-icons mr-2 text-black">warning</i>
              <strong></strong> To download iSimulate pre-release software,
              please access Community via Safari.
            </p>
          </div>
        </div>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";

export default {
  name: "MyPreReleases",
  components: {
    UserMenu,
    CommunityCard,
    Footer,
  },
  data: function() {
    return {
      preReleaseSuffixes: ["/RealitiBundle.plist", "/ALSi.plist", "/CTGi.plist", "/nano.plist", "/RealitiDemo.plist", "/SimscopeCheck.plist"],
      preReleases: ["REALITI Check", "ALSi", "CTGi", "iSimulate Nano", "Demo", "Simscope Check"],
      linkPrefix: `itms-services://?action=download-manifest&url=${
        process.env.VUE_APP_API_SUFFIX
      }/api/prerelease/download/`,
      preReleaseLegacyLinks: [
        "itms-services://?action=download-manifest&url=https://hub.isimulate.com/pre-release/download/realiti/RealitiBundle.plist",
        "itms-services://?action=download-manifest&url=https://hub.isimulate.com/pre-release/download/alsi/ALSi.plist",
        "itms-services://?action=download-manifest&url=https://hub.isimulate.com/pre-release/download/ctgi/CTGi.plist",
        "itms-services://?action=download-manifest&url=https://hub.isimulate.com/pre-release/download/nano/nano.plist",
        "itms-services://?action=download-manifest&url=https://hub.isimulate.com/pre-release/download/realitidemo/RealitiDemo.plist",
        "itms-services://?action=download-manifest&url=https://hub.isimulate.com/pre-release/download/simscopecheck/SimscopeCheck.plist",
      ],
    };
  },
  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
  },
};
</script>

<style scoped>
.pre-release {
  color: #ff9817;
}

.pre-release .icon-container i {
  font-size: 50px;
  border: 5px solid #ff9817;
}
</style>
